import '../../css/style.scss'
import '../../css/leaderboard.scss'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {Sound} from '../../../shared/scripts/Sound'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController'
import {UIWFooterController} from '../ui_html/UIWFooterController'
import {UIWLeaderboardController} from './UIWLeaderboardController'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'

void init()

async function init() {
    Sound.loadSounds()

    await EntryShared.initializeEntry()

    assignScrollbarWidth()
    const headerController = new UIWHeaderController()
    new UIWFooterController()
    new UIWLeaderboardController()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}

function assignScrollbarWidth() {
    // Combining https://stackoverflow.com/a/68293406/6333444 and https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
    const div = document.createElement('div')
    div.style.overflowY = 'scroll'
    document.body.appendChild(div)
    const inner = document.createElement('div')
    div.appendChild(inner)
    document.body.style.setProperty('--scrollbar-width', `${div.offsetWidth - inner.offsetWidth}px`)
    document.body.removeChild(div)
}
